import { render, staticRenderFns } from "./VideoGlm.vue?vue&type=template&id=a1d85da2&scoped=true"
import script from "./VideoGlm.vue?vue&type=script&lang=js"
export * from "./VideoGlm.vue?vue&type=script&lang=js"
import style0 from "./VideoGlm.vue?vue&type=style&index=0&id=a1d85da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d85da2",
  null
  
)

export default component.exports